export default "__VITE_ASSET__mW7GPtzU__"